import React, { useState, useEffect } from 'react';

/**
 * Returns element button to close a element, this appear in the right top corner
 * @param {function} close function to close element
 * @param {boolean} floatElement if true the button will be floating and over the element
 * @param {string} containerStyle style for the container default is 'w-100 pt-2 pb-2 text-end pe-2'
 * @param {string} buttonStyle style for the button default is 'btn btn-sm btn-danger bg-red3 mt-2 shadow ps-3 pe-3 scale-continue-05 border border-warning border-3 text-bold round-xxl'
 * @returns 
 */
const CloseButton = (p) => {
    const floatElement = p.floatElement ?? false;
    const style = floatElement ? { position: 'absolute', top: 0, right: 0, zIndex: 3 } : {};
    const close = p.close ?? (() => { });

    //optional style
    const containerStyle = p.containerStyle ?? 'w-100 pt-2 pb-2 text-end pe-2';
    const buttonStyle = p.buttonStyle ?? 'btn btn-sm btn-danger bg-red3 mt-2 shadow ps-3 pe-3 scale-continue-05 border border-warning border-3 text-bold round-xxl';

    return (
        <div className={containerStyle} style={style}>
            <button className={buttonStyle} onClick={close}>Cerrar</button>
        </div>
    )
}

export default CloseButton;